import * as React from 'react';

import '../../styles/to/index.scss';

const TO = (): JSX.Element => <></>;

export default TO;
